<template>
  <div class="checkout-overlay-actions" :class="alignment">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-actions {
    width: 100%;
    min-height: 80px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.right {
      justify-content: flex-end;
    }

    &.left {
      justify-content: flex-start;
    }

    .platform & {
      width: auto;
      max-height: 80px;
      margin: 0 20px;
      padding: 20px 0;
      flex: 1;
      border-top: 1px solid rgba(#000, 0.1)
    }

    button + button {
      margin-left: 8px;
    }
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-actions',
    props: {
      alignment: String
    }
  }
</script>
